import { View } from 'foundations-components/components/View';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useHighestProductLevelFromInventory } from '../../v2/hooks/useProductInventory';
import UnlockAIContent from './UnlockAIContent';
import UnlockAIContentTabLayout from './UnlockAIContentTabLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const UnlockAISection = () => {
  const isMobile = useIsMobile();
  const {
    highestProductLevel
  } = useHighestProductLevelFromInventory();
  const isFreeOrProspect = highestProductLevel === 'FREE';
  return /*#__PURE__*/_jsx(PageSection, {
    use: isMobile ? 'default' : undefined,
    children: /*#__PURE__*/_jsx(View, {
      paddingBlock: isMobile ? '800' : '0',
      children: isFreeOrProspect ? /*#__PURE__*/_jsx(UnlockAIContentTabLayout, {}) : /*#__PURE__*/_jsx(UnlockAIContent, {})
    })
  });
};
export default UnlockAISection;